import React from "react";
import { NavLink } from "react-router-dom";

import styled from "styled-components";
import introduceImg from "../assets/image/introduce.png";

export default function IntroduceBanner() {
  const IntroduceBanner = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    flex-direction: row;

    background-color: #e6ecf3;

    & > img {
      max-width: 50%;
    }
    & > div {
      width: 100%;
      display: flex;
      flex-direction: column;

      padding: 50px 80px;
      padding-left: 0;
      gap: 30px;

      & > * {
        white-space: pre-wrap;
      }

      & > div:first-child {
        width: 100%;

        color: var(--color-blue);
        font-size: 40px;
        font-weight: bold;
        text-align: right;
      }

      & > div:nth-child(2) {
        width: 100%;

        font-size: 20px;
        color: var(--color-darkgrey);
        letter-spacing: 1px;
        line-height: 36px;
        text-align: right;
      }
    }
  `;

  const LinkBtn = styled(NavLink)`
    width: 200px;
    height: 40px;

    border-radius: 21px;
    border: solid 2px var(--color-blue);

    color: var(--color-darkgrey);
    font-size: 20px;
    text-align: center;
    text-decoration: none;
    line-height: 36px;

    align-self: flex-end;
    background-color: white;

    cursor: pointer;
  `;

  return (
    <IntroduceBanner>
      <img src={introduceImg} alt="introduce.png" />
      <div>
        <div>VaronTech는</div>
        <div>
          {
            "최첨단 기술과 지속적인 연구개발을 통해\n고객들에게 최고의 제품을 제공하며\n비즈니스를 성공적으로 선도하고 있습니다."
          }
        </div>
        <LinkBtn to="about/message">회사 소개 바로가기</LinkBtn>
      </div>
    </IntroduceBanner>
  );
}
